// Shared render geometry, without React updates on every animation frame.
// The logo owns this surface; Greg only reads it to pass behind the artwork.
export interface LogoOcclusion {
  canvas: HTMLCanvasElement
  left: number
  top: number
  width: number
  height: number
  readyAt: number
}

export const logoScene: { current: LogoOcclusion | null } = { current: null }
